import {
  CardIcon,
  GroupIcon,
  LaptopIcon,
  ResizeIcon,
  SmileIcon,
  TableIcon,
  WalletIcon,
} from '@/public/icons';
import whatIsDeskImage from '@/public/what_is_desk.webp';
import whatIsMobImage from '@/public/why_image.webp';

const whatIs = {
  title: 'What is Orcatec?',
  subTitle:
    'Orcatec is your all-in-one home services management software designed to save you time, money, and boost productivity. It organizes all your tasks, synchronizes the work of your team, technicians, and clients.',
  items: [
    {
      title: '60% Times Saved on Reporting Invoicing & Planning',
      icon: CardIcon,
    },
    { title: '120% Return On Investments On the First Year', icon: WalletIcon },
    { title: 'Customize Online Platform To Your Field', icon: LaptopIcon },
    { title: 'Quickbooks Automatic Synchronization', icon: GroupIcon },
  ],
  image: {
    imageMob: whatIsMobImage.src,
    imageDesk: whatIsDeskImage.src,
  },
};
const philosophy = {
  title: 'Our Philosophy',
  items: [
    {
      title: `Orcatec is a skilled development team and a real business owner. Field experience combined with leading software technologies giving you an outstanding competitive edge.`,
    },
    {
      title: `Our goal is to provide the highest quality product at the most affordable price. We aim to improve your business and turn it into a more profitable one.`,
    },
    {
      title: `We want to help any company that operates in the service field become efficient by simplifying the process and by making it easier to keep track of sales. Orcatec clients gain an immediate peace of mind knowing we act as a liaison between your service/sales team, distributor and clients.`,
    },
  ],
  image: {
    imageMob: whatIsMobImage.src,
    imageDesk: whatIsMobImage.src,
  },
};

const cards = [
  {
    title: 'Optimization and Savings',
    description:
      'Orcatec helps with the automation of routine tasks like planning, dispatching, and invoicing, saving your time and resources.',
    icon: ResizeIcon,
  },
  {
    title: 'Enhanced Customer Satisfaction',
    description:
      'Access to detailed information and transparent pricing builds trust and ensures customer satisfaction, always providing better service.',
    icon: SmileIcon,
  },
  {
    title: 'Business Development',
    description:
      'Orcatec will enable you to scale your business by providing tools for effective management of teams, projects, and clients.',
    icon: TableIcon,
  },
];

const why = {
  leftSide: {
    title: 'Why Orcatec?',
    items: [
      {
        text: 'The founder and CEO at ORCATEC knows first - hand what it’s like to be on the field. His 14 years of experience in the HVAC business as a sales consultant, project manager and later a co-founder of a multimillion business has given him an in-depth understanding of the features  needed for an ideal software.',
      },
      {
        text: 'His experience and knowledge of the field, combined with the skills of a highly qualified team of software engineers, turned this vision into reality.',
      },
    ],
  },
  rightSide: {
    text: 'My goal was to make an efficient software that helps guys, just like me, eliminate the headache of keeping track of paper proposals and equipment orders. By making it affordable, I want everyone, be it a new start-up or a seasoned corporation to have access to this resource that will help your company work smarter, not harder.',
    name: 'Alex Gold',
    position: 'CEO at Orcatec',
  },
};

export { whatIs, philosophy, cards, why };
